import React from "react";
import "./Styles.css";

const About = () => {
  return (
    <div className="cellframe singlecell">Author: jiu.hong.sun@gmail.com</div>
  );
};

export default About;
